export default "__VITE_ASSET__CFRwqB40__"